import './About.css'
import AboutDetail from "./AboutDetail";
import Separator from "../separator/Separator";
import {useMediaQuery} from "react-responsive";



const About = ({abouts}) => {
    const isDesktop = useMediaQuery({ minWidth: 992 });
    return (
        <>
            <div className={"container"}>
                {isDesktop ? <>
                    <Separator  first={"legume/voatavo.webp"} second={"legume/corn.webp"} third={"legume/tomate.webp"}></Separator>
                </> : <></>}
                <section id={"about"} className={"about "}>
                    <div className={"about-container"}>

                            {!isDesktop ? <>
                                <div className={"about-sep"}>
                                    <Separator  first={"legume/voatavo.webp"} second={"legume/corn.webp"} third={"legume/tomate.webp"}></Separator>
                                </div>
                            </> : <></>}


                        <h2 className={"title animate"}>Qui sommes-nous?</h2>
                            <div className={"row"}>
                                {
                                    abouts.map((about, index) => (
                                        <AboutDetail flip={index % 2 === 0} about={about} change={about.change}> </AboutDetail>
                                    ))
                                }


                        </div>
                        <Separator first={"legume/tomate.webp"} second={"legume/robot.webp"} third={"legume/voatavo.webp"}></Separator>

                    </div>
                </section>
            </div>

        </>
    )
}

export default About;